import React from 'react';
import { twMerge } from 'tailwind-merge';

const Divider = ({ className }) => <hr className={twMerge(className, 'divider')} />;

export default Divider;
